<div class="sales-list">
  <div class="sales-list__item mb-6" *ngFor="let sale of sales()">
    <app-sales-list-item [sale]="sale" [userInfo]="userInfo" (onDelete)="handleDelete()"></app-sales-list-item>
  </div>
</div>
